import { FormEvent, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { countries } from '../data/countries';
import { userService } from '../services/userService';

const ProfileForm = () => {
  const { user, refreshProfile } = useAuth();
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    username: '',
    countryCode: ''
  });
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    setForm({
      first_name: user.first_name,
      last_name: user.surname,
      email: user.email,
      username: user.username,
      countryCode: user.country_code
    });
  }, [user]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    setStatus(null);
    try {
      await userService.updateProfile(form);
      await refreshProfile();
      setStatus('Profile updated');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="card" onSubmit={handleSubmit}>
      <h3>Profile information</h3>
      <div className="input-group">
        <label htmlFor="first_name">First name</label>
        <input
          id="first_name"
          name="first_name"
          placeholder="e.g. Alex"
          value={form.first_name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="input-group">
        <label htmlFor="last_name">Last name</label>
        <input
          id="last_name"
          name="last_name"
          placeholder="e.g. Franklin"
          value={form.last_name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="input-group">
        <label htmlFor="email">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          placeholder="e.g. alex@gate.haus"
          value={form.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="input-group">
        <label htmlFor="username">Username</label>
        <input
          id="username"
          name="username"
          placeholder="e.g. alexfranklin"
          value={form.username}
          onChange={handleChange}
          required
        />
      </div>
      <div className="input-group">
        <label htmlFor="countryCode">Country</label>
        <select id="countryCode" name="countryCode" value={form.countryCode} onChange={handleChange} required>
          <option value="">e.g. United Kingdom</option>
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
        </select>
      </div>
      {status && (
        <p style={{ color: 'var(--success)' }} role="status">
          {status}
        </p>
      )}
      {error && (
        <p style={{ color: 'var(--danger)' }} role="alert">
          {error}
        </p>
      )}
      <button className="primary-button" type="submit" disabled={loading}>
        {loading ? 'Saving…' : 'Save changes'}
      </button>
    </form>
  );
};

export default ProfileForm;
